module.exports = __webpack_public_path__ + "img/vertical-dots-icon.8827c53e.svg";